module.exports = require("core-js/library/fn/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/symbol/iterator.js
// module id = 645
// module chunks = 0